import 'antd/dist/antd.css';
import { createElement, Component } from 'react';
import { Row, Col, Input, Divider } from 'antd';
import { UpOutlined, DownOutlined, SearchOutlined, CheckOutlined } from '@ant-design/icons';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var styles = {
  "a8select": "_35GRA",
  "ellipsis": "_qn8qt",
  "selected": "_1q33I",
  "text": "_2UBVh",
  "placeholder": "_RGCc-",
  "action": "_3l_cP",
  "list": "_1BnHg",
  "contents": "_59IjH",
  "search": "_2tH10",
  "input": "_2nYSh",
  "ant-input-prefix": "_3NLM_",
  "item": "_2iNi2",
  "title": "_3JY_a",
  "subtitle": "_3d0mg",
  "divider": "_2KvLb",
  "checkbox": "_1CPNZ",
  "selection": "_2ehAD"
};

var Select = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.selectedItem = function (item) {
      var selectedIds = _this.state.selected;
      var selectedItems = [];
      var list = _this.props.data;
      var viewSelected = "";
      var displayCount = 0;

      if (selectedIds.indexOf(item[_this.state.optionValue]) > -1) {
        selectedIds.splice(selectedIds.indexOf(item[_this.state.optionValue]), 1);
      } else {
        if (_this.state.multiSelect) {
          selectedIds.push(item[_this.state.optionValue]);
        } else {
          selectedIds = [];
          selectedIds.push(item[_this.state.optionValue]);
        }
      }

      for (var l in list) {
        for (var s in selectedIds) {
          if (list[l][_this.state.optionValue] == selectedIds[s]) {
            selectedItems.push(list[l]);
            displayCount = displayCount + 1;

            if (displayCount <= _this.state.displayLimit) {
              viewSelected = viewSelected + " " + (viewSelected == "" ? "" : ", ") + " " + list[l][_this.state.optionLabel];
            }
          }
        }
      }

      if (displayCount > _this.state.displayLimit) {
        viewSelected = viewSelected + " +" + (displayCount - _this.state.displayLimit);
      }

      _this.setState({
        selected: selectedIds,
        viewSelected: viewSelected
      });

      if (typeof _this.props.onChange == "function") {
        _this.props.onChange(selectedIds, selectedItems);
      }
    };

    _this.onSearch = function (e) {
      var list = _this.props.data ? _this.props.data : [];
      var filteredList = [];

      if (e.target.value.length > 0) {
        for (var l in list) {
          if (list[l][_this.state.title].toLocaleLowerCase().includes(e.target.value)) {
            filteredList.push(list[l]);
          }
        }
      } else {
        filteredList = list;
      }

      _this.setState({
        list: filteredList
      });
    };

    _this.setStateValue = function (props) {
      var list = [];
      var listStr = "";
      var selected = props.options.defaultValue ? props.options.defaultValue : [];
      var minSelect = null;
      var selectedStr = JSON.stringify(selected);
      var multiSelect = false;
      var isSearch = false;
      var displayLimit = props.options.displayLimit ? props.options.displayLimit : 3;
      var icon = props.options.icon ? props.options.icon : null;
      var optionIcon = props.options.optionIcon ? props.options.optionIcon : null;
      var title = props.options.title ? props.options.title : null;
      var placeholder = props.options.placeholder ? props.options.placeholder : "";
      var subTitle = props.options.subTitle ? props.options.subTitle : null;
      var primaryColor = props.options.primaryColor ? props.options.primaryColor : "#ff7f43";
      var contentHeight = 300;
      var onSelectToggle = false;
      var optionValue = "_id";
      var disabled = props.options.disabled ? props.options.disabled : false;
      var disableSelectedView = props.options.disableSelectedView;
      var optionLabel = "";
      var viewSelected = "";
      var displayCount = 0;

      if (props && props.data != null && props.data != undefined) {
        list = props.data;
        listStr = JSON.stringify(list);
      }

      if (optionIcon) {
        icon = null;
      }

      if (title) {
        optionLabel = title;
      }

      if (props.options.minSelect && typeof props.options.minSelect == "number" && props.options.minSelect >= 0) {
        minSelect = props.options.minSelect;
      }

      if (props.options.contentHeight && typeof props.options.contentHeight == "number" && props.options.contentHeight >= 20) {
        contentHeight = props.options.contentHeight;
      }

      if (props.options.onSelectToggle || disableSelectedView) {
        onSelectToggle = true;
      }

      if (props.options.optionLabel) {
        optionLabel = props.options.optionLabel;
      }

      if (props.options.isSearch) {
        isSearch = true;
      }

      if (props.options.multiSelect) {
        multiSelect = true;
      }

      if (props.options.optionValue) {
        optionValue = props.options.optionValue;
      }

      for (var s in selected) {
        for (var l in list) {
          if (list[l][optionValue] == selected[s]) {
            displayCount = displayCount + 1;

            if (displayCount <= displayLimit) {
              viewSelected = viewSelected + " " + (viewSelected == "" ? "" : ", ") + " " + list[l][optionLabel];
            }
          }
        }
      }

      if (displayCount > displayLimit) {
        viewSelected = viewSelected + " +" + (displayCount - displayLimit);
      }

      _this.setState({
        disabled: disabled,
        icon: icon,
        minSelect: minSelect,
        selectedStr: selectedStr,
        optionIcon: optionIcon,
        isSearch: isSearch,
        selected: selected,
        multiSelect: multiSelect,
        displayLimit: displayLimit,
        onSelectToggle: onSelectToggle,
        disableSelectedView: disableSelectedView,
        list: list,
        listStr: listStr,
        title: title,
        subTitle: subTitle,
        optionLabel: optionLabel,
        optionValue: optionValue,
        placeholder: placeholder,
        primaryColor: primaryColor,
        viewSelected: viewSelected,
        contentHeight: contentHeight
      });
    };

    _this.state = {
      icon: null,
      listStr: null,
      optionIcon: null,
      multiSelect: false,
      isSearch: false,
      selected: [],
      selectedStr: [],
      title: null,
      subTitle: null,
      list: [],
      placeholder: "",
      optionValue: "_id",
      disabled: false,
      viewSelected: "",
      optionLabel: null,
      displayLimit: 3,
      onSelectToggle: false,
      disableSelectedView: false,
      primaryColor: "#ff7f43",
      contentHeight: 300,
      minSelect: null
    };
    return _this;
  }

  var _proto = Select.prototype;

  _proto.componentWillMount = function componentWillMount() {
    this.setStateValue(this.props);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (props && props.data != null && props.data != undefined && JSON.stringify(props.data) != this.state.listStr) {
      this.setState({
        list: props.data,
        listStr: JSON.stringify(props.data)
      });
    }

    if (props.options) {
      if (props.options.disabled !== undefined) {
        this.setState({
          disabled: props.options.disabled
        });
      }

      if (props.options.primaryColor !== undefined && props.options.primaryColor !== null) {
        this.setState({
          primaryColor: props.options.primaryColor
        });
      }

      if (props.options.defaultValue && JSON.stringify(props.options.defaultValue) != this.state.selectedStr) {
        this.setState({
          selected: props.options.defaultValue,
          selectedStr: JSON.stringify(props.options.defaultValue)
        });
        var displayCount = 0;
        var viewSelected = "";

        for (var s in props.options.defaultValue) {
          for (var l in props.data) {
            if (props.data[l][this.state.optionValue] == props.options.defaultValue[s]) {
              displayCount = displayCount + 1;

              if (displayCount <= this.state.displayLimit) {
                viewSelected = viewSelected + " " + (viewSelected == "" ? "" : ", ") + " " + props.data[l][this.state.optionLabel];
              }
            }
          }
        }

        if (displayCount > this.state.displayLimit) {
          viewSelected = viewSelected + " +" + (displayCount - this.state.displayLimit);
        }

        this.setState({
          viewSelected: viewSelected
        });
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return createElement(Row, {
      className: styles.a8select + " a8-uicomponents-select"
    }, createElement(Col, {
      span: 24
    }, !this.state.disableSelectedView && createElement(Row, {
      className: styles.selected + " selected",
      onClick: function onClick() {
        if (!_this2.state.disabled) {
          _this2.setState({
            onSelectToggle: !_this2.state.onSelectToggle
          });
        }
      }
    }, createElement(Col, {
      className: this.state.viewSelected == "" ? styles.placeholder + " placeholder" : styles.text + " text",
      span: 22
    }, this.state.viewSelected == "" ? this.state.placeholder : this.state.viewSelected), createElement(Col, {
      className: styles.action + " action",
      span: 2
    }, this.state.onSelectToggle ? createElement(UpOutlined, null) : createElement(DownOutlined, null))), createElement(Row, {
      className: styles.list + " list",
      style: {
        display: this.state.onSelectToggle ? "block" : "none",
        position: this.state.disableSelectedView ? "relative" : "absolute",
        zIndex: this.state.disableSelectedView ? 9998 : 9999
      },
      onMouseLeave: function onMouseLeave() {
        return _this2.setState({
          onSelectToggle: _this2.state.disableSelectedView
        });
      }
    }, createElement(Col, {
      span: 24,
      className: styles.search,
      style: {
        display: this.state.isSearch ? "block" : "none"
      }
    }, createElement(Input, {
      className: styles.input + " input",
      prefix: createElement(SearchOutlined, null),
      onChange: this.onSearch
    })), createElement(Col, {
      span: 24,
      className: styles.contents + " contents",
      style: {
        maxHeight: this.state.contentHeight + "px"
      }
    }, this.state.list && this.state.list.map(function (item) {
      return createElement(Row, {
        className: styles.item + " item",
        key: item[_this2.state.optionValue],
        onClick: function onClick() {
          return _this2.selectedItem(item);
        }
      }, createElement(Col, {
        span: 2
      }, createElement("div", {
        className: styles.checkbox,
        style: {
          borderColor: _this2.state.primaryColor,
          marginTop: _this2.state.optionIcon || _this2.state.icon ? "20px" : "6px"
        }
      }, _this2.state.selected.indexOf(item[_this2.state.optionValue]) > -1 && createElement(CheckOutlined, {
        className: styles.selection,
        style: {
          color: _this2.state.primaryColor
        }
      }))), _this2.state.optionIcon && createElement(Col, {
        span: 4
      }, createElement("img", {
        className: styles.icon + " icon",
        src: item[_this2.state.optionIcon]
      })) || _this2.state.icon && createElement(Col, {
        span: 4
      }, createElement("img", {
        className: styles.icon + " icon",
        src: _this2.state.icon
      })), createElement(Col, {
        span: _this2.state.optionIcon || _this2.state.icon ? 18 : 22
      }, _this2.state.title && createElement(Row, {
        className: styles.title + " title"
      }, createElement(Col, {
        span: 24,
        className: styles.ellipsis
      }, item[_this2.state.title])), _this2.state.subTitle && createElement(Row, {
        className: styles.subtitle + " subtitle"
      }, createElement(Col, {
        span: 24,
        className: styles.ellipsis
      }, item[_this2.state.subTitle]))), createElement(Divider, {
        className: styles.divider + " divider",
        type: "horizontal"
      }));
    })))));
  };

  return Select;
}(Component);

export { Select };